import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import {Field, Form} from "react-final-form";
import {i18n} from "../../../utils/i18n";
import {Button, TextField} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import {Trans} from "@lingui/macro";
import React from "react";

const UpdatePreferencesForm = (props) => {
    return (
        <Form
            onSubmit={props.onSubmit}
            {...props}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit}>
                    <Box p={1}>
                        <Field name="silenceTimeout" defaultValue={3600} placeholder={"Délai"} label={"Délai de silence (secondes)"}>
                            {props => <TextField type="number" onChange={e => {
                                if(e.target.value == "") {
                                    props.form.setFieldValue("silenceTimeout", 3600);
                                    return;
                                }

                                const fieldValue = +e.target.value;

                                if(isNaN(fieldValue) || e.target.value < 10) return e.preventDefault();

                                props.form.setFieldValue("silenceTimeout", fieldValue);
                            }} variant="outlined" fullWidth {...props} {...props.input}/>}
                        </Field>
                    </Box>
                    <Divider variant="middle"/>
                    <Button fullWidth type="submit" className="shadow-2 mb-4"><Trans>Update my Preferences</Trans></Button>
                </form>
            )}/>
    );
}

export default UpdatePreferencesForm;